import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { MatIconModule } from '@angular/material/icon';
import { MatChipsModule } from '@angular/material/chips';
import { MatListModule } from '@angular/material/list';
import { LicenseUserAvatarModule } from '@portal-core/license-users/components/license-user-avatar/license-user-avatar.module';
import { LicenseUserForLicenseAsyncModule } from '@portal-core/license-users/pipes/license-user-for-license-async/license-user-for-license-async.module';
import { ProjectAvatarModule } from '@portal-core/projects/components/project-avatar/project-avatar.module';
import { ProjectAsyncModule } from '@portal-core/projects/pipes/project-async/project-async.module';
import { ClickModule } from '@portal-core/ui/clicking/directives/click/click.module';
import { FilterBarComponent } from './filter-bar.component';

@NgModule({
  declarations: [
    FilterBarComponent
  ],
  imports: [
    CommonModule,
    ClickModule,
    MatChipsModule,
    MatIconModule,
    MatListModule,
    ProjectAvatarModule,
    ProjectAsyncModule,
    LicenseUserAvatarModule,
    LicenseUserForLicenseAsyncModule
  ],
  exports: [
    FilterBarComponent
  ]
})
export class FilterBarModule { }
